/* Penoblo PLP: Facetten-Formular (GET). Desktop: Auto-Submit bei Änderung.
   Mobil: Filter im Drawer, „Ergebnisse anzeigen" submittet. Sort submittet immer.
   Plus: aufklappbare Filtergruppen + Drawer-Steuerung. */
(function () {
  // Hero-Button „Mehr erfahren" -> sanft zum ausführlichen Kategorietext (#cat-info)
  var scrollBtn = document.querySelector('[data-plp-scrollto]');
  if (scrollBtn) scrollBtn.addEventListener('click', function (e) {
    var target = document.getElementById('cat-info');
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  var form = document.getElementById('PnbPlpForm');
  if (!form) return;
  var isMobile = function () { return window.matchMedia('(max-width: 989.98px)').matches; };

  // Nach einem Filter-/Sort-/Seiten-Reload an der Filterleiste ankern statt am
  // Hero-Bild (Kunde muss nicht jedes Mal runterscrollen). Nur wenn solche Params
  // gesetzt sind; ohne Filter bleibt der Hero normal oben.
  if (/[?&](filter\.|sort_by=|page=)/.test(window.location.search)) {
    var plpAnchor = document.querySelector('.plp-pillbar') || form;
    if (plpAnchor && plpAnchor.scrollIntoView) {
      requestAnimationFrame(function () { plpAnchor.scrollIntoView({ block: 'start' }); });
    }
  }

  // aufklappbare Filtergruppen
  form.querySelectorAll('[data-fgroup-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var g = btn.closest('[data-fgroup]');
      if (!g) return;
      g.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', g.classList.contains('is-collapsed') ? 'false' : 'true');
    });
  });

  // Auto-Submit: Sortierung immer; übrige Filter nur am Desktop (mobil -> Apply)
  form.addEventListener('change', function (e) {
    if (e.target.matches('select[data-plp-sort]')) { form.requestSubmit ? form.requestSubmit() : form.submit(); return; }
    if (!isMobile()) { form.requestSubmit ? form.requestSubmit() : form.submit(); }
  });

  // ---- A11y-Helfer: fokussierbare Elemente + Tab-Fokusfalle im offenen Panel ----
  function focusablesIn(el) {
    return [].slice.call(el.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (n) { return n.offsetParent !== null; });
  }
  function trapTab(panel, e) {
    if (e.key !== 'Tab') return;
    var f = focusablesIn(panel);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // Mobile-Drawer (auf Desktop dieselbe Sidebar, dort aber KEIN Dialog)
  var side = form.querySelector('[data-plp-side]');
  var scrim = form.querySelector('[data-plp-scrim]');
  var openBtn = form.querySelector('[data-plp-open]');
  var closeBtn = form.querySelector('[data-plp-close]');
  var sideLastFocus = null;
  // Mobil: geschlossener Off-Canvas-Drawer als Dialog + inert (nicht fokussierbar);
  // Desktop: normale Sidebar (Dialog-/inert-Attribute entfernen).
  function syncSideA11y(open) {
    if (!side) return;
    if (isMobile()) {
      side.setAttribute('role', 'dialog');
      side.setAttribute('aria-modal', 'true');
      if (open) side.removeAttribute('inert'); else side.setAttribute('inert', '');
    } else {
      side.removeAttribute('role'); side.removeAttribute('aria-modal'); side.removeAttribute('inert');
    }
  }
  // QA #6: App-Leiste ausblenden, solange irgendein Sheet offen ist
  function syncSheetClass() {
    var anyOpen = (side && side.classList.contains('is-open')) ||
                  (sortSheet && sortSheet.classList.contains('is-open'));
    document.documentElement.classList.toggle('pnb-sheet-open', !!anyOpen);
  }
  function setOpen(o) {
    if (side) side.classList.toggle('is-open', o);
    if (scrim) scrim.classList.toggle('is-on', o);
    document.documentElement.style.overflow = (o && isMobile()) ? 'hidden' : '';
    syncSideA11y(o);
    if (o && isMobile()) {
      sideLastFocus = document.activeElement;
      var f = (closeBtn && closeBtn.offsetParent) ? closeBtn : focusablesIn(side)[0];
      if (f) f.focus();
    } else if (!o && sideLastFocus) {
      try { sideLastFocus.focus(); } catch (x) {}
      sideLastFocus = null;
    }
    syncSheetClass();
  }
  if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
  if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
  if (side) side.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); setOpen(false); }
    else if (side.classList.contains('is-open')) trapTab(side, e);
  });
  syncSideA11y(false); // Initialzustand: geschlossen

  // Sort-Bottom-Sheet (mobil) – echter modaler Dialog (role/aria-modal im Markup)
  var sortSheet = document.querySelector('[data-plp-sortsheet]');
  var sortOpenBtn = form.querySelector('[data-plp-sortopen]');
  var sortSelect = form.querySelector('select[data-plp-sort]');
  var sortLastFocus = null;
  function setSortOpen(o) {
    if (sortSheet) {
      sortSheet.classList.toggle('is-open', o);
      sortSheet.setAttribute('aria-hidden', o ? 'false' : 'true'); // war statisch true -> SR sah es nie offen
    }
    document.documentElement.style.overflow = o ? 'hidden' : '';
    if (o && sortSheet) { sortLastFocus = document.activeElement; var f = focusablesIn(sortSheet)[0]; if (f) f.focus(); }
    else if (!o && sortLastFocus) { try { sortLastFocus.focus(); } catch (x) {} sortLastFocus = null; }
    syncSheetClass();
  }
  if (sortOpenBtn) sortOpenBtn.addEventListener('click', function () { setSortOpen(true); });
  if (sortSheet) {
    sortSheet.querySelectorAll('[data-plp-sortclose]').forEach(function (el) {
      el.addEventListener('click', function () { setSortOpen(false); });
    });
    sortSheet.querySelectorAll('[data-plp-sortval]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var val = opt.getAttribute('data-plp-sortval');
        if (sortSelect) sortSelect.value = val;
        setSortOpen(false);
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
    sortSheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); setSortOpen(false); }
      else if (sortSheet.classList.contains('is-open')) trapTab(sortSheet, e);
    });
  }

  // Breakpoint-Wechsel: auf Desktop offene Sheets schliessen (sonst Scroll-Lock);
  // auf Mobil den Drawer-A11y-Zustand neu setzen.
  var desktopMq = window.matchMedia('(min-width: 990px)');
  desktopMq.addEventListener('change', function (e) {
    if (e.matches) { setOpen(false); setSortOpen(false); }
    else { syncSideA11y(side && side.classList.contains('is-open')); }
  });

})();
